import 'CssFolder/user-role-function-map/user-role-function-map-table.scss';
import { Checkbox, Spinner } from 'construct-ui';
import _ from "lodash";
import moment from 'moment';
import { formats } from '../../../config/constants';
import UserRoleFunctionMapModel from '../../../models/user-role-function-map/user-role-function-map.model';
import ViewBase from "../../view-base.view";

export default function UserRoleFunctionMapView() {
  ViewBase.call(this);

  const DELAY_TIME = 200;

  let tableDataHasChanged = false
  let userRoleFilterText = ''
  let tableDataColumns = []
  let tableData = [];

  const getUserRoleDataAccess = () => {
    this.showLoading();
    UserRoleFunctionMapModel.getUserRoleDataAccess()
      .then((result) => {
        tableDataColumns = result.columnData;
        tableData = result.userRoleData.map(({ dataRestriction, role }) => ({
          role,
          dataRestriction: dataRestriction.reduce(
            (result, { dataRestrictionTypeID, value }) => {
              result[dataRestrictionTypeID] = value;
              return result;
            },
            {}
          ),
        }));
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const debouncedChangeText =_.debounce((e) => {
    userRoleFilterText = e.target.value;
    m.redraw()
  }, DELAY_TIME);

  const handleChangeFilterText = (e) => {
    e.redraw = false;
    debouncedChangeText(e);
  }

  const handleUpdateUserRoleDataAccess = () => {
    this.showLoading();
    const payload = tableData.flatMap(({ role, dataRestriction }) => {
      return Object.entries(dataRestriction).map(([dataRestrictionTypeID, value]) => ({
        userRoleId: role.code,
        dataRestrictionTypeID,
        value,
      }));
    });
    UserRoleFunctionMapModel.updateUserRoleDataAccess(payload)
      .then(() => {
        this.showMessage(
          this.getText("EM00000762", "Changes have been saved."),
          this.getText("EM0000004", "Success"),
          getUserRoleDataAccess
        );
      })
      .catch((error) => this.handleError(error))
      .finally(() => {
        tableDataHasChanged = false;
        this.hideLoading();
      });
  };

  const handleDownloadExcel = () =>{
    this.hideLoading();
    UserRoleFunctionMapModel.downloadExcel('User Role Function Map_' + moment().format(formats.apiDateFormat))
    .catch((error) => {
      this.handleError(error);
    })
    .finally(() => {
      this.hideLoading();
    });
  }

  const leavePageEventListener = (e) => {
    if (tableDataHasChanged && !confirm(this.getText('EM00000776', 'Changes you made may not be saved'))) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  };

  return {
    oncreate: () => {
      addEventListener('route', leavePageEventListener);
      addEventListener('beforeunload', leavePageEventListener);
    },
    onremove: () => {
      removeEventListener('route', leavePageEventListener);
      removeEventListener('beforeunload', leavePageEventListener);
    },
    oninit: () => {
      getUserRoleDataAccess();
    },
    view: () => {
      return [
        // Table section
        m('.card',
          m('.card-body',
            m('.row.g-2',
              m('.col-12',
                m('.d-flex.justify-content-between.mb-2',
                  m('.filters',
                    m('input.form-control', {
                      style: 'width: 280px;',
                      placeholder: this.getText("LT00000806", "User role filter"),
                      oninput: handleChangeFilterText
                    }),
                  ),
                  m('a.btn.btn-primary', 
                    { onclick: handleDownloadExcel },
                    m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                  ),
                ),
              ),
              m('.col-12.p-0',
                m('.table-responsive.table-fixed-header',
                  m('table.table', [
                    m('thead.thead-bggrey.sticky-thead',
                      m('tr.align-middle', 
                        m('th[scope="col"]',this.getText("LT00000060", "User Role")),
                        tableDataColumns.map(({ name }) => m('th[scope="col"]', name))
                      )
                    ),
                    m('tbody',
                      (tableData.length == 0) &&
                      m('tr.align-middle',
                        m('td',{ colspan: tableDataColumns.length } , this.getText("EM00000141", "No records found."))
                      ),
                      tableData.length > 0 &&
                      tableData.filter(row => row.role.name.toLocaleLowerCase().includes(userRoleFilterText.trim().toLocaleLowerCase())).map((row) => 
                        m('tr.align-middle',
                          m('td', row.role.name),
                          tableDataColumns.map(col => m('td', 
                            m(Checkbox, {
                              checked: !!row.dataRestriction[col.code],
                              onchange: e => {
                                row.dataRestriction[col.code] = e.target.checked;
                                tableDataHasChanged = true
                              }
                            })
                            )
                          )
                        )
                      )
                    )
                  ])
                ),
                m('.d-flex.justify-content-end.gap-2',
                  m('button.btn.btn-primary', {
                    onclick: handleUpdateUserRoleDataAccess
                  }, this.getText("LT00000022", "Save"))
                ),
              )
            )
          )
        ),
        // Table section - end

        this.getBaseViews()
      ];
    }
  };
}
